import { getAuthTokenDetails, getCustomerAuthentication, getDsbLocalStorageKey, localStore } from '@wkda/funnel-utils';
import { parse } from 'query-string';
import Cookies from 'universal-cookie';
import { formNames } from './formNames';
export function createMarketingProperties(config, marketingProperties) {
  let _defaultMappers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : sharedMarketingProps;
  return function $createMarketingProperties(mappers, values) {
    return _defaultMappers.concat(mappers).reduce(function mapperReducer(payload, mapperFn) {
      return Object.assign({}, payload, mapperFn({
        config,
        values,
        marketingProperties,
        properties: payload
      }));
    }, {});
  };
}
export const hideOnlinePriceMPMapper = function hideOnlinePriceMPMapper(_ref) {
  let {
    config,
    marketingProperties
  } = _ref;
  if (config?.featuresFlags?.selfEvaHideOnlinePriceBucket === true) {
    return {
      [marketingProperties.hideOnlinePrice.propertyId]: 1
    };
  }
  return {};
};
export const selfEvaluationRedirectMPMapper = function selfEvaluationRedirectMPMapper(_ref2) {
  let {
    config,
    marketingProperties
  } = _ref2;
  if (config?.featuresFlags?.redirectToSelfEvaluation === true) {
    return {
      [marketingProperties.slimFunnels.propertyId]: 1
    };
  }
  return {};
};
export const selfEvaluationAffiliateMPMapper = function selfEvaluationAffiliateMPMapper(_ref3) {
  let {
    config,
    marketingProperties
  } = _ref3;
  const affiliateScenario = config?.featuresFlags?.affiliateScenario;
  if (['affiliate', 'whitelabel'].includes(affiliateScenario)) {
    return {
      [marketingProperties.affiliateScenario.propertyId]: affiliateScenario
    };
  }
  return {};
};
export const honeypotMPMapper = function honeypotMPMapper(_ref4) {
  let {
    config,
    marketingProperties,
    values
  } = _ref4;
  if (config?.featuresFlags?.honeyPotEmail === true && values[formNames.honeyPotEmail]) {
    return {
      [marketingProperties.honeyPot.propertyId]: 1
    };
  }
  return {};
};
export const postCodeMapper = function postCodeMapper(_ref5) {
  let {
    marketingProperties,
    values
  } = _ref5;
  if (values.location) {
    return {
      [marketingProperties.postalCode.propertyId]: JSON.stringify(values.location)
    };
  }
  return {};
};
export const gdprPreferencesMPMapper = function gdprPreferencesMPMapper(_ref6) {
  let {
    marketingProperties
  } = _ref6;
  const cookies = new Cookies();
  const gdprCookie = cookies.get('gdpr_preferences');
  if (gdprCookie) {
    return {
      [marketingProperties.GDPRPreferences.propertyId]: JSON.stringify(gdprCookie)
    };
  }
  return {};
};
export const personalFieldsMapper = function personalFieldsMapper(_ref7) {
  let {
    marketingProperties
  } = _ref7;
  const fields = ['mobile', 'location', 'email', 'firstName', 'lastName', 'SELLPOINT', 'SELL_TYPES'];
  const content = [];
  fields.forEach(fieldName => {
    if (document.querySelector(`[name=${fieldName}]`)) {
      content.push(fieldName);
    }
  });
  if (content.length) {
    return {
      [marketingProperties.carlead2StepCustomerDataFields.propertyId]: JSON.stringify(content)
    };
  }
  return {};
};
export const skipOfferEmailMapper = function skipOfferEmail(_ref8) {
  let {
    marketingProperties,
    config
  } = _ref8;
  const {
    propertyId,
    value
  } = marketingProperties.skipOfferEmail;
  const {
    skipOfferEmail
  } = config?.featuresFlags ?? {};
  // eslint-disable-next-line eqeqeq
  if (skipOfferEmail === false || skipOfferEmail == undefined) {
    return {};
  }
  return {
    [propertyId]: value
  };
};
export const emailSSOSourceMapper = function emailSSOSource(_ref9) {
  let {
    marketingProperties,
    values
  } = _ref9;
  const {
    emailSSOSource
  } = values;
  const {
    propertyId
  } = marketingProperties.emailSSOSource;
  if (emailSSOSource) {
    return {
      [propertyId]: emailSSOSource
    };
  }
  return {};
};
export const partnerFunnelMPMapper = function (_ref0) {
  let {
    marketingProperties,
    config
  } = _ref0;
  let props = {};
  if (config.isPartnerFunnel && typeof window !== 'undefined') {
    const {
      partnerAPIKey,
      partnerDomain
    } = marketingProperties;
    const currentURL = new URL(window.location.href);
    const waKey = currentURL.searchParams.get('wa_key');
    const url = currentURL.searchParams.get('partner_url');
    if (waKey) {
      props[partnerAPIKey.propertyId] = waKey;
    }
    if (url) {
      props[partnerDomain.propertyId] = url;
    }
  }
  return props;
};
export const estateAgentMPMapper = function (_ref1) {
  let {
    marketingProperties,
    config
  } = _ref1;
  const {
    propertyId,
    value
  } = marketingProperties.estateAgentFunnel;
  const {
    estateAgentFunnel
  } = config?.featuresFlags ?? {};
  if (!estateAgentFunnel) {
    return {};
  }
  return {
    [propertyId]: value
  };
};
export const licensePlateMarketingPropertyMapper = function licensePlateMarketingPropertyMapper(_ref10) {
  let {
    values,
    marketingProperties
  } = _ref10;
  const {
    propertyId
  } = marketingProperties.licensePlate;
  if (!values.licensePlate) {
    return {};
  }
  return {
    [propertyId]: cleanLicensePlate(values.licensePlate)
  };
};
const LICENSE_PLATE_NOT_RECOGNIZED = 'licensePlateNotRecognized';
const LICENSE_PLATE = 'licensePlate';
const LICENSE_PLATE_FALLBACK = 'fallbackType';
export const invalidLicensePlateMarketingPropertyMapper = function licensePlateMarketingPropertyMapper(_ref11) {
  let {
    marketingProperties,
    config
  } = _ref11;
  const {
    propertyId
  } = marketingProperties.licensePlateNotRecognized;
  const query = parse(typeof window !== 'undefined' ? window.location.search : '');
  const notRecognised = query?.error === LICENSE_PLATE_NOT_RECOGNIZED;
  const licensePlate = localStore.getJSON(getDsbLocalStorageKey(config.fullLocale))?.licensePlate?.value;
  if (!licensePlate || !notRecognised || typeof licensePlate !== 'string') {
    return {};
  }
  return {
    [propertyId]: cleanLicensePlate(licensePlate)
  };
};
export const licensePlateFallbackMarketingPropertyMapper = function licensePlateFallbackMarketingPropertyMapper(_ref12) {
  let {
    marketingProperties
  } = _ref12;
  const {
    propertyId
  } = marketingProperties.licensePlateFallback;
  const query = parse(typeof window !== 'undefined' ? window.location.search : '');
  const licensePlateFallback = query?.[LICENSE_PLATE_FALLBACK];
  const fallback = typeof licensePlateFallback === 'string' ? cleanQueryParam(licensePlateFallback) : '';
  if (fallback !== LICENSE_PLATE) {
    return {};
  }
  return {
    [propertyId]: 1
  };
};
export const unspecifiedMarketingExperimentMapper = function unspecifiedMarketingExperimentMapper(_ref13) {
  let {
    marketingProperties,
    config
  } = _ref13;
  const unspecifiedExperiment = config?.featuresFlags?.unspecifiedExperiment;
  const {
    propertyId
  } = marketingProperties.unspecifiedExperiment;
  if (unspecifiedExperiment === true) {
    return {
      [propertyId]: 1
    };
  }
  return {};
};
export const dropOffEmailDelayMapper = function dropOffEmailDelayMapper(_ref14) {
  let {
    marketingProperties,
    config
  } = _ref14;
  const dropOffEmailDelayInMinutes = config?.featuresFlags?.dropOffEmailDelayInMinutes;
  const {
    propertyId
  } = marketingProperties.dropOffEmailDelay;
  if (typeof dropOffEmailDelayInMinutes === 'number' && Number.isInteger(dropOffEmailDelayInMinutes)) {
    return {
      [propertyId]: dropOffEmailDelayInMinutes
    };
  }
  return {};
};
export const leadCIDChannelMapper = function leadCIDChannelMapper(_ref15) {
  let {
    marketingProperties,
    config,
    values
  } = _ref15;
  const shouldSend = config?.featuresFlags?.sendLeadCIDChannel;
  if (shouldSend === false) {
    return {};
  }
  const CID_COOKIE_KEY = 'WKDA';
  const {
    propertyId
  } = marketingProperties.leadCIDChannel;
  const {
    latestCIDchannel
  } = values;
  const cookies = new Cookies();
  const wkdaCookie = cookies.get(CID_COOKIE_KEY);
  const parsedLatestCIDchannel = getLatestCIDchannel(wkdaCookie);
  const channelValue = parsedLatestCIDchannel ?? latestCIDchannel;
  return channelValue !== undefined ? {
    [propertyId]: channelValue
  } : {};
};
export const noEmailMarketingPropertyMapper = function noEmailMarketingPropertyMapper(_ref16) {
  let {
    marketingProperties
  } = _ref16;
  const {
    propertyId
  } = marketingProperties.noEmailField;
  return {
    [propertyId]: 1
  };
};
export const socialLoginMarketingPropertyMapper = function socialLoginMarketingPropertyMapper(_ref17) {
  let {
    marketingProperties,
    values
  } = _ref17;
  const properties = {};
  const auth = getCustomerAuthentication();
  const tokenDetails = getAuthTokenDetails();

  // user logged-in via social login & email matches
  if (tokenDetails.authType === 'social' && auth?.user?.email === values.email) {
    properties[marketingProperties.socialLogin.propertyId] = 1;
    // if one-tap login was used
    if (auth.one_tap) {
      properties[marketingProperties.oneTapLogin.propertyId] = 1;
    }
  }
  return properties;
};
export const mileageUnitMarketingPropertyMapper = function (_ref18) {
  let {
    marketingProperties,
    config
  } = _ref18;
  const {
    propertyId
  } = marketingProperties.mileageUnit;
  const {
    locale
  } = config;
  if (locale !== 'sv-SE') {
    return {};
  }
  return {
    [propertyId]: 'km'
  };
};
export const sharedMarketingProps = [hideOnlinePriceMPMapper, selfEvaluationRedirectMPMapper, honeypotMPMapper, gdprPreferencesMPMapper, skipOfferEmailMapper, emailSSOSourceMapper, partnerFunnelMPMapper, estateAgentMPMapper, invalidLicensePlateMarketingPropertyMapper, licensePlateFallbackMarketingPropertyMapper, selfEvaluationAffiliateMPMapper, unspecifiedMarketingExperimentMapper, dropOffEmailDelayMapper, leadCIDChannelMapper, socialLoginMarketingPropertyMapper, mileageUnitMarketingPropertyMapper];
export function createMarketingPropertiesDictionary() {
  return {
    honeyPot: {
      propertyId: 3470,
      value: 1
    },
    slimFunnels: {
      propertyId: 8762,
      value: 1
    },
    hideOnlinePrice: {
      propertyId: 8764,
      value: 1
    },
    GDPRPreferences: {
      propertyId: 8790,
      value: ''
    },
    postalCode: {
      propertyId: 5902,
      value: ''
    },
    skipOfferEmail: {
      propertyId: 8755,
      value: 1
    },
    partnerAPIKey: {
      propertyId: 9100,
      value: ''
    },
    partnerDomain: {
      propertyId: 9101,
      value: ''
    },
    estateAgentFunnel: {
      propertyId: 6351,
      value: 'estate_agent_funnel'
    },
    emailSSOSource: {
      propertyId: 8745,
      value: ''
    },
    licensePlate: {
      propertyId: 8600,
      value: ''
    },
    licensePlateNotRecognized: {
      propertyId: 8601,
      value: ''
    },
    licensePlateFallback: {
      propertyId: 6350,
      value: 1
    },
    affiliateScenario: {
      propertyId: 9102,
      value: 'none'
    },
    unspecifiedExperiment: {
      propertyId: 8756,
      value: 1
    },
    dropOffEmailDelay: {
      propertyId: 9204,
      value: 0
    },
    leadCIDChannel: {
      propertyId: 8700,
      value: ''
    },
    noEmailField: {
      propertyId: 8743,
      value: 1
    },
    obfuscatedPrice: {
      propertyId: 8781,
      value: ''
    },
    oneTapLogin: {
      propertyId: 6850,
      value: 1
    },
    socialLogin: {
      propertyId: 6851,
      value: 1
    },
    diversionAccount: {
      propertyId: 6852,
      value: 1
    },
    carlead2StepCustomerDataFields: {
      propertyId: 5910,
      value: ''
    },
    mileageUnit: {
      propertyId: 9602,
      value: 'km'
    }
  };
}
function cleanLicensePlate() {
  let licensePlate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return licensePlate.replace(/\W|_/g, '');
}
function cleanQueryParam(query) {
  return query.replace(/[^\w\s]/gi, '');
}
function getLatestCIDchannel(cookie) {
  if (!cookie || !decodeURIComponent) {
    return undefined;
  }
  return decodeURIComponent(cookie).split('||')?.at(-1)?.split('&')?.at(0)?.split('_')?.at(1);
}